import { colors, shape } from './theme';

export type ShadcnTokenValue =
  | { hex: string; kind: 'hex'; source?: string }
  | { kind: 'raw'; raw: string };

const hex = (value: string, source?: string): ShadcnTokenValue => ({
  hex: value,
  kind: 'hex',
  source,
});
const raw = (value: string): ShadcnTokenValue => ({ kind: 'raw', raw: value });

/**
 * Mapping from shadcn CSS custom property names to their @anyroad/theme source.
 * Consumed by packages/components/shadcn-components/scripts/generate-tokens.ts
 * to produce src/tokens.css. Edit here; run `nx build @anyroad/shadcn-components`
 * (or the generate-tokens script directly) to regenerate.
 */
export const shadcnTokenMap = {
  '--background': hex(colors.background.light, 'colors.background.light'),
  '--foreground': hex(colors.text.primary, 'colors.text.primary'),
  '--card': hex('#ffffff'),
  '--card-foreground': hex(colors.text.primary, 'colors.text.primary'),
  '--popover': hex('#ffffff'),
  '--popover-foreground': hex(colors.text.primary, 'colors.text.primary'),
  '--primary': hex(colors.primary, 'colors.primary'),
  '--primary-foreground': hex('#ffffff'),
  '--secondary': hex(colors.secondary, 'colors.secondary'),
  '--secondary-foreground': hex('#ffffff'),
  '--muted': hex(colors.background.light, 'colors.background.light'),
  '--muted-foreground': hex(colors.text.secondary, 'colors.text.secondary'),
  '--accent': hex(colors.background.active, 'colors.background.active'),
  '--accent-foreground': hex(colors.text.primary, 'colors.text.primary'),
  '--destructive': hex(colors.error, 'colors.error'),
  '--destructive-foreground': hex('#ffffff'),
  '--border': hex(colors.border, 'colors.border'),
  '--input': hex(colors.borderAction, 'colors.borderAction'),
  '--ring': hex(colors.borderFocus, 'colors.borderFocus'),
  '--radius': raw(shape.shadcnRadius),
} as const satisfies Record<string, ShadcnTokenValue>;
